import React from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { debounce } from 'lodash';
import GrowContainer from 'components/Global/GrowContainer/GrowContainer.jsx';
import Text from '@bit/knotchinc.web-react-components.text';
import { connect } from 'react-redux';
import Tag from 'components/Global/Tag/Tag.jsx';
import Input from '@bit/knotchinc.web-react-components.input';
import ListSync from '@bit/knotchinc.web-react-components.list-sync';
import { SelectedText, SelectedBar, TilesContainer, PickerColumn, PickerContainer, ButtonContainer, ModalButton,
} from 'components/Global/EntityPicker/styled.js';
import { SET_SETTINGS_PUBLISHERS_FILTER, SET_SETTINGS_BRANDS_FILTER } from 'components/Pages/Settings/actions.js';
import EntityTile from './EntityTile.jsx';

export class EntityPicker extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedEntities: [],
    };
    this.debouncedSearch = debounce(val => this.searchEntities(val), 200);
  }

  searchEntities(value) {
    this.props.search(value);
  }

  select(entity) {
    const { multiple } = this.props;
    const { selectedEntities } = this.state;
    let newSelected = [...selectedEntities];

    if (newSelected.find(el => el.public_id === entity.public_id)) {
      newSelected = newSelected.filter(el => el.public_id !== entity.public_id);
    } else if (multiple) {
      newSelected.push(entity);
    } else {
      newSelected = [entity];
    }

    this.setState({ selectedEntities: newSelected });
  }

  removeEntity(entityId) {
    const { selectedEntities } = this.state;
    let newSelected = [...selectedEntities];

    if (newSelected.find(el => el.public_id === entityId)) {
      newSelected = newSelected.filter(el => el.public_id !== entityId);
    }

    this.setState({ selectedEntities: newSelected });
  }

  submit() {
    const { selectedEntities } = this.state;
    const { submit, multiple } = this.props;

    if (selectedEntities) {
      multiple ? submit(selectedEntities) : submit(selectedEntities[0]);
    }

    this.setState({ selectedEntities: [] });
  }

  render() {
    const { title, brandsList, publishersList, brandFetch, publisherFetch, multiple, excludedIds } = this.props;
    const { selectedEntities } = this.state;
    const canSubmit = selectedEntities.length > 0;
    const excludeEntities = excludedIds ? el => !excludedIds.includes(el.public_id) : () => true;
    const halfLayout = brandFetch && publisherFetch;
    let container = null;

    if (this._scrollContainerRef) {
      container = this._scrollContainerRef._container;
    }

    return (
      <PickerContainer>
        <Text fontSize="30px" fontWeight="100" mb="18px">{title}</Text>
        {multiple &&
          <Text fontSize="12px" color="#939AAB" mb="18px">
            You can select however many you’d like.
          </Text>}
        {multiple &&
          <GrowContainer type="height" from={0} to={'auto'} toggle={selectedEntities.length > 0} style={{ display: 'block', width: '100%' }}>
            <SelectedBar>
              <SelectedText>SELECTED</SelectedText>
              {selectedEntities.map(el => <Tag
                selected
                type="competitor"
                deleteEnabled
                data={el.name}
                icon={el.logo_url}
                onClick={() => this.removeEntity(el.public_id)}
              />)}
            </SelectedBar>
          </GrowContainer>
        }
        <Input hideErrorText placeholder={`Search...`} callback={value => this.debouncedSearch(value)} />
        <TilesContainer halfLayout={halfLayout} >
          <PerfectScrollbar ref={el => { this._scrollContainerRef = el; }}>
            {brandFetch &&
            <PickerColumn>
              <ListSync
                fetch={clear => brandFetch(clear)}
                listStore={brandsList}
                loadOnScroll
                actionType={SET_SETTINGS_BRANDS_FILTER}
                filterCondition={excludeEntities}
                container={container}
              >
                <EntityTile onClick={item => this.select(item)} selectedEntities={selectedEntities} />
              </ListSync>
            </PickerColumn>}
            {publisherFetch &&
            <PickerColumn>
              <ListSync
                fetch={clear => publisherFetch(clear)}
                listStore={publishersList}
                loadOnScroll
                actionType={SET_SETTINGS_PUBLISHERS_FILTER}
                filterCondition={excludeEntities}
                container={container}
              >
                <EntityTile onClick={item => this.select(item)} selectedEntities={selectedEntities} />
              </ListSync>
            </PickerColumn>}
          </PerfectScrollbar>
        </TilesContainer>
        <ButtonContainer>
          <ModalButton
            canSubmit={canSubmit}
            onClick={() => canSubmit && this.submit()}
          >
            DONE
          </ModalButton>
        </ButtonContainer>
      </PickerContainer>
    );
  }
}

const mapStateToProps = ({
  Account,
  Settings: { brandsList, publishersList },
}) => ({ Account, brandsList, publishersList });

const mapDispatchToProps = (dispatch, { brandFetch, publisherFetch }) => ({
  search: (value) => {
    const filters = { searchQuery: value, searchBy: value.length > 0 ? 'name' : '', pageNum: 1 };
    publisherFetch && dispatch({ type: SET_SETTINGS_PUBLISHERS_FILTER, filters });
    brandFetch && dispatch({ type: SET_SETTINGS_BRANDS_FILTER, filters });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(EntityPicker);
